import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Col, Row, Modal } from '_zari/core'

import { ValidationSchema } from '../_shared/validation'
import NombreFormGroup from '../_shared/formGroups/nombre'
import Telefono1FormGroup from '../_shared/formGroups/telefono1'
import Telefono2FormGroup from '../_shared/formGroups/telefono2'
import Email1FormGroup from '../_shared/formGroups/email1'
import Email2FormGroup from '../_shared/formGroups/email2'
import ComentarioFormGroup from '../_shared/formGroups/comentario'

const NuevoContacto = ({ handleClose, show, agregarContacto }) => {
  const formInitialValues = React.useMemo(
    () => ({
      nombre: '',
      telefono1: '',
      telefono2: '',
      email1: '',
      email2: '',
      comentario: ''
    }),
    []
  )

  const submitHandler = async data => {
    agregarContacto(data)
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>NUEVO CONTACTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Telefono1FormGroup iError={errors.telefono1} iTouched={touched.telefono1} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Telefono2FormGroup iError={errors.telefono2} iTouched={touched.telefono2} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Email1FormGroup iError={errors.email1} iTouched={touched.email1} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Email2FormGroup iError={errors.email2} iTouched={touched.email2} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <ComentarioFormGroup iError={errors.comentario} iTouched={touched.comentario} fIsSubmitting={isSubmitting} />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoContacto
